import React, { useEffect, useRef } from 'react';
import { Kicker, FadeUp } from './ui';
const REEL_IMG = 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=2000&q=80';

/**
 * Scroll-linked expand, driven by a rAF loop reading getBoundingClientRect
 * (never scroll events, which do not fire reliably inside preview wrappers).
 */
function useReelScroll() {
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);
  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    const reduce = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      wrap.style.width = '100%';
      wrap.style.borderRadius = '0px';
      if (imgRef.current) imgRef.current.style.transform = 'scale(1)';
      return;
    }
    let raf = 0;
    let lastEase = -1;
    const loop = () => {
      const el = wrapRef.current;
      if (el) {
        const vh = window.innerHeight || 800;
        const startWidth = window.innerWidth < 768 ? 86 : 72;
        const rect = el.getBoundingClientRect();
        const t = Math.min(1, Math.max(0, (vh * 0.95 - rect.top) / (vh * 0.75)));
        const ease = 1 - Math.pow(1 - t, 3);
        if (Math.abs(ease - lastEase) > 0.001) {
          lastEase = ease;
          el.style.width = `${startWidth + (100 - startWidth) * ease}%`;
          el.style.borderRadius = `${20 * (1 - ease)}px`;
          if (imgRef.current) {
            imgRef.current.style.transform = `scale(${1.18 - 0.18 * ease})`;
          }
        }
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);
  return {
    wrapRef,
    imgRef
  };
}
export function Showreel() {
  const {
    wrapRef,
    imgRef
  } = useReelScroll();
  return <section id="reel" className="pt-24 md:pt-32" data-id="element-173">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10" data-id="element-174">
        <Kicker ig="Lee Anya" en="Watch the reel" data-id="element-175" />
      </div>
      <FadeUp className="mt-6 md:mt-8" data-id="element-176">
        <div ref={wrapRef} className="group relative mx-auto overflow-hidden" style={{
        width: '72%',
        borderRadius: '20px',
        background: 'linear-gradient(150deg, #1f1e24, #111013)'
      }} data-id="element-177">
          <img ref={imgRef} src={REEL_IMG} alt="Director framing a shot on a Nkali production" className="h-[58vh] max-h-[700px] min-h-[320px] w-full object-cover will-change-transform" style={{
          transform: 'scale(1.18)'
        }} data-id="element-178" />
          <span className="absolute inset-0" style={{
          background: 'linear-gradient(180deg, rgba(17,16,19,0.12), rgba(17,16,19,0.5))'
        }} aria-hidden="true" data-id="element-179" />

          <span className="absolute inset-0 flex items-center justify-center" aria-hidden="true" data-id="element-180">
            <span className="relative flex h-32 w-32 md:h-44 md:w-44 items-center justify-center" data-id="element-181">
              <svg viewBox="0 0 100 100" className="spin-slow absolute inset-0 h-full w-full" data-id="element-182">
                <defs data-id="element-183">
                  <path id="nk-circle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" data-id="element-184" />
                </defs>
                <text className="font-monoui" style={{
                fontSize: '8.2px',
                letterSpacing: '1.6px',
                fill: 'var(--paper)'
              }} data-id="element-185">
                  <textPath href="#nk-circle" data-id="element-186">NKALI STUDIO ✦ SHOWREEL 2026 ✦ LAGOS ✦</textPath>
                </text>
              </svg>
              <span className="flex h-16 w-16 md:h-20 md:w-20 items-center justify-center rounded-full transition-transform duration-500 group-hover:scale-110" style={{
              background: 'var(--danfo)',
              color: 'var(--ink)'
            }} data-id="element-187">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-188">
                  <path d="M8 5.5V18.5L19 12L8 5.5Z" data-id="element-189" />
                </svg>
              </span>
            </span>
          </span>

          <span className="font-monoui absolute bottom-5 left-5 md:bottom-8 md:left-8 text-[10px] md:text-xs uppercase tracking-[0.18em] opacity-80" data-id="element-190">
            Reel '26 · 02:14
          </span>
          <span className="font-monoui absolute bottom-5 right-5 md:bottom-8 md:right-8 text-[10px] md:text-xs uppercase tracking-[0.18em] opacity-80" data-id="element-191">
            Sound on ✦
          </span>
        </div>
      </FadeUp>
    </section>;
}